import {
  DeleteParams,
  DeleteResult,
  fetchUtils,
  HttpError,
  Identifier,
  RaRecord,
} from 'react-admin';
import { defaultHeaders } from './utils';
import getOne from './getOne';
import {
  JsonApiResource,
  createReactAdminValidationError,
  getJsonApiErrorBody,
  getJsonApiErrorMessage,
  getJsonApiErrorStatus,
} from './JsonApiTypes';

export default function deleteFn(apiUrl: string, httpClient = fetchUtils.fetchJson) {
  const getOneFn = getOne(apiUrl, httpClient);

  return async <T extends RaRecord<Identifier>>(
    resource: string,
    params: DeleteParams<T>,
  ): Promise<DeleteResult<T & JsonApiResource>> => {
    try {
      const existingRecord = (await getOneFn(resource, params)).data as T & JsonApiResource;

      const url = `${apiUrl}/${resource}/${params.id}`;

      await httpClient(url, {
        method: 'DELETE',
        headers: defaultHeaders,
      });

      return { data: existingRecord };
    } catch (error) {
      const validationErrors = createReactAdminValidationError(error as HttpError);
      throw new HttpError(
        getJsonApiErrorMessage(error as HttpError, 'Error deleting record'),
        getJsonApiErrorStatus(error as HttpError),
        {
          ...validationErrors,
          apiResponse: getJsonApiErrorBody(error),
        },
      );
    }
  };
}
